<script>
    // Import tabs structure
    import Tabs from '../tabs/tabs.vue';
    import Tab from '../tabs/tab.vue';

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    // Import dashboards
    import DashboardTransferred from './management/Transferred.vue';
    import DashboardCurrent from './management/Current.vue';
    import DashboardClosed from './management/Closed.vue';

    // Import widgets
    import WidgetDate from '../widgets/Date.vue';

    export default {
        mixins: [mixin],
        components: {
            Tabs,
            Tab,
            WidgetDate,
            DashboardTransferred,
            DashboardCurrent,
            DashboardClosed,
        },
        data() {
            return {
                resetCount: 0,
                filtersActive: false,
            }
        },
        methods: {
            resetFilters() {
                this.resetCount++;
                this.filtersActive = false;
            },
            onFilter() {
                this.filtersActive = true;
            },
        }
    };
</script>

<template>
    <div v-if="loading" class="has-text-centered">
        <div class="lds-facebook has-text-grey-lighter">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div v-else class="tile is-ancestor is-vertical">
        <div class="tile is-child">
            <div class="is-flex is-justify-content-space-between">
                <div class="has-background-white">
                    <button v-if="filtersActive" @click="resetFilters" class="button is-danger is-outlined">
                        <span>{{ $store.getters.getText('dashboardLabelRemovefilters') }}</span>
                        <span class="icon"><i class="fa-solid fa-times"></i></span>
                    </button>
                </div>
                <div class="has-background-white">
                    <button @click="$store.commit('toggleHighContrast');" :class="['button', 'is-primary', $store.getters.getHighContrast ? '' : 'is-outlined']">
                        <span class="mr-1">{{ $store.getters.getText('dashboardLabelHighcontrast') }}:</span>
                        <span v-if="$store.getters.getHighContrast">{{ $store.getters.getText('dashboardLabelOn') }}</span>
                        <span v-else>{{ $store.getters.getText('dashboardLabelOff') }}</span>
                        <span class="icon"><i class="fa-solid fa-palette"></i></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="tile is-parent is-flex-wrap-wrap">
            <div class="tile is-child is-3">
                <widget-date />
            </div>
            <tabs :has-urlparams="true"
                  tabs-wrapper-classes="tile is-child is-9"
                  tabs-classes="dashboard-widget dashboard-widget--filter is-toggle"
                  :dropdown-label="$store.getters.getText('dashboardLabelMore')"
                  :navigate-label="$store.getters.getText('dashboardLabelNavigate')"
                  :active-bold="false">
                <tab :title="$store.getters.getText('dashboardTabTransferred')" :persistent="false" class-names="tile is-parent is-vertical">
                    <dashboard-transferred :key="`transferred-${resetCount}`" @filter="onFilter" />
                </tab>
                <tab :title="$store.getters.getText('dashboardTabCurrent')" :persistent="false" class-names="tile is-parent is-vertical">
                    <dashboard-current :key="`current-${resetCount}`" @filter="onFilter" />
                </tab>
                <tab :title="$store.getters.getText('dashboardTabClosed')" :persistent="false" class-names="tile is-parent is-vertical">
                    <dashboard-closed :key="`closed-${resetCount}`" @filter="onFilter" />
                </tab>
            </tabs>
        </div>
    </div>
</template>
